import { useEffect, useState } from "react";
import TabNav from "../../components/TabNav/TabNav";
import StatusPill from "../../components/StatusPill/StatusPill";
import { supportService } from "../../services/api";
import { useNotification } from "../../components/Notifications/NotificationContext";
import { fmtDate } from "../utils/dateUtils/fmtDate";
import "./Support.css";

const TABS = [
    { id: "support", label: "Suporte", icon: "fas fa-headset" },
    { id: "report", label: "Denúncia", icon: "fas fa-flag" },
];

const STATUS_COLORS = {
    pending: "yellow",
    reviewing: "blue",
    resolved: "green",
    rejected: "red",
};

const EMPTY_FORM = {
    reported_bot_username: "",
    report_type: "",
    platform: "",
    redirect_link: "",
    content_link: "",
    description: "",
    pix_code: "",
    declaration: false,
};

function SupportTab() {
    return (
        <div className="support-cards">



            <a
                className="support-channel"
                href={`https://wa.me/5583999384126?text=${encodeURIComponent(
                    "Olá, tudo bem? Preciso de ajuda com a Spectrum."
                )}`}
                target="_blank"
                rel="noopener noreferrer"
            >
                <div className="support-channel-icon is-whatsapp">
                    <i className="fab fa-whatsapp" />
                </div>
                <div className="support-channel-text">
                    <strong>Suporte no WhatsApp</strong>
                    <span>+55 83 9938-4126 — atendimento direto</span>
                </div>
            </a>

            <a
                className="support-channel"
                href="https://chat.whatsapp.com/JfJ5PfkmItc9BfjfuaEioD"
                target="_blank"
                rel="noopener noreferrer"
            >
                <div className="support-channel-icon is-whatsapp">
                    <i className="fab fa-whatsapp" />
                </div>
                <div className="support-channel-text">
                    <strong>Grupo de Networking</strong>
                    <span>Comunidade no WhatsApp — troque ideias e novidades</span>
                </div>
            </a>
            <a
                className="support-channel"
                href="https://www.instagram.com/spectrumvips/"
                target="_blank"
                rel="noopener noreferrer"
            >
                <div className="support-channel-icon is-instagram">
                    <i className="fab fa-instagram" />
                </div>
                <div className="support-channel-text">
                    <strong>Instagram</strong>
                    <span>@spectrumvips — novidades e avisos</span>
                </div>
            </a>
            <a
                className="support-channel"
                href="https://t.me/SpectrumSuporte"
                target="_blank"
                rel="noopener noreferrer"
            >
                <div className="support-channel-icon is-telegram">
                    <i className="fab fa-telegram-plane" />
                </div>
                <div className="support-channel-text">
                    <strong>Suporte no Telegram</strong>
                    <span>@SpectrumSuporte — atendimento direto</span>
                </div>
            </a>




        </div>
    );
}

function ReportTab() {
    const { showError, showSuccess } = useNotification();
    const [form, setForm] = useState(EMPTY_FORM);
    const [options, setOptions] = useState({ types: [], platforms: [] });
    const [reports, setReports] = useState([]);
    const [sending, setSending] = useState(false);
    const [formOpen, setFormOpen] = useState(false); // controla o form no mobile

    useEffect(() => {
        supportService.reportOptions()
            .then(({ data }) => setOptions(data))
            .catch(() => { });
        loadReports();
    }, []);

    const loadReports = () => {
        supportService.myReports()
            .then(({ data }) => setReports(data.reports || []))
            .catch(() => { });
    };

    const set = (name) => (e) => {
        const value = e.target.type === "checkbox" ? e.target.checked : e.target.value;
        setForm((prev) => ({ ...prev, [name]: value }));
    };

    const isCsam = form.report_type === "menor_de_idade";

    // Limites alinhados com o backend (support.py)
    const LIMITS = {
        reported_bot_username: 120,
        redirect_link: 500,
        content_link: 500,
        description: 4000,
        pix_code: 2000,
    };

    const Counter = ({ field }) => {
        const len = (form[field] || "").length;
        const max = LIMITS[field];
        return (
            <span className={`report-counter ${len >= max ? "is-limit" : ""}`}>
                {len}/{max}
            </span>
        );
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (!form.declaration) {
            showError("Marque a declaração de veracidade para enviar.");
            return;
        }

        setSending(true);
        try {
            await supportService.createReport(form);
            showSuccess("Denúncia registrada. Nossa equipe vai analisar.");
            setForm(EMPTY_FORM);
            setFormOpen(false);
            loadReports();
        } catch (err) {
            console.error(err);
            showError(err?.response?.data?.error || "Erro ao enviar denúncia.");
        } finally {
            setSending(false);
        }
    };

    return (
        <div className="report-layout">
            {/* Botão de abrir o form (só mobile) */}
            {!formOpen && (
                <button
                    type="button"
                    className="btn-primary report-mobile-toggle"
                    onClick={() => setFormOpen(true)}
                >
                    <i className="fas fa-flag" /> Nova denúncia
                </button>
            )}

            {/* FORM */}
            <form className={`report-form-card ${formOpen ? "is-open" : ""}`} onSubmit={handleSubmit}>
                <div className="report-form-head">
                    <h3><i className="fas fa-flag" /> Denunciar um bot</h3>


                    <button class="manage-bots-close mobile-show" onClick={() => setFormOpen(false)}
                        aria-label="Fechar formulário"><i class="fas fa-times"></i></button>
                </div>

                <div className="report-warning">
                    <i className="fas fa-triangle-exclamation" />
                    <div>
                        <strong>Não envie nem anexe arquivos, prints ou mídias.</strong> A Spectrum
                        não armazena evidências de conteúdo — apenas o texto desta denúncia.
                        Guardar ou repassar material ilegal (especialmente envolvendo menores)
                        é crime, mesmo a título de "prova" (art. 241-B do ECA). Evidências devem
                        ser entregues diretamente às autoridades:{" "}
                        <a href="https://new.safernet.org.br/denuncie" target="_blank" rel="noopener noreferrer">
                            SaferNet
                        </a>{" "}
                        ou Polícia Federal.
                    </div>
                </div>

                <div className="report-field">
                    <label className="spt-label">@ do bot denunciado <span className="required">*</span></label>
                    <input
                        type="text"
                        className='input3'
                        placeholder="@bot_denunciado"
                        value={form.reported_bot_username}
                        onChange={set("reported_bot_username")}
                        required
                        maxLength={LIMITS.reported_bot_username}
                    />
                    <Counter field="reported_bot_username" />
                </div>

                <div className="report-field">
                    <label className="spt-label">Tipo da denúncia <span className="required">*</span></label>
                    <select className="form-select" value={form.report_type} onChange={set("report_type")} required>
                        <option value="">Selecione...</option>
                        {options.types.map((t) => (
                            <option key={t.value} value={t.value}>{t.label}</option>
                        ))}
                    </select>
                </div>

                {isCsam && (
                    <div className="report-warning report-urgent">
                        <i className="fas fa-circle-exclamation" />
                        <div>
                            <strong>Denúncia urgente.</strong> Além de registrar aqui, denuncie
                            imediatamente na{" "}
                            <a href="https://new.safernet.org.br/denuncie" target="_blank" rel="noopener noreferrer">
                                SaferNet
                            </a>{" "}
                            e no{" "}
                            <a href="https://www.gov.br/pf/pt-br/canais_atendimento/comunicacao-de-crimes" target="_blank" rel="noopener noreferrer">
                                canal da Polícia Federal
                            </a>. Não baixe, não salve e não compartilhe o conteúdo.
                        </div>
                    </div>
                )}

                <div className="report-field">
                    <label className="spt-label">Plataforma utilizada</label>
                    <select className="form-select" value={form.platform} onChange={set("platform")}>
                        {options.platforms.map((p) => (
                            <option key={p.value} value={p.value}>{p.label}</option>
                        ))}
                    </select>
                </div>

                <div className="report-field">
                    <label className="spt-label">Link de redirecionamento utilizado <em>(opcional)</em></label>
                    <input
                        type="url"
                        className='input3'
                        placeholder="https://..."
                        value={form.redirect_link}
                        onChange={set("redirect_link")}
                        maxLength={LIMITS.redirect_link}
                    />
                    <Counter field="redirect_link" />
                </div>

                <div className="report-field">
                    <label className="spt-label">Link do bot ou do conteúdo <em>(opcional)</em></label>
                    <input
                        type="url"
                        placeholder="https://t.me/..."
                        className='input3'
                        value={form.content_link}
                        onChange={set("content_link")}
                        maxLength={LIMITS.content_link}
                    />
                    <Counter field="content_link" />
                </div>

                <div className="report-field">
                    <label className="spt-label">Descrição da denúncia <span className="required">*</span></label>
                    <textarea
                        className="spt-textarea"
                        placeholder="Descreva o que aconteceu, sem colar conteúdo do material denunciado. Mínimo 20 caracteres."
                        value={form.description}
                        onChange={set("description")}
                        required
                        minLength={20}
                        maxLength={LIMITS.description}
                    />
                    <Counter field="description" />
                </div>

                <div className="report-field">
                    <label className="spt-label">PIX utilizado <em>(copia e cola, opcional)</em></label>
                    <input
                        type="text"
                        placeholder="00020126...br.gov.bcb.pix..."
                        className='input3'
                        value={form.pix_code}
                        onChange={set("pix_code")}
                        maxLength={LIMITS.pix_code}
                    />
                    <Counter field="pix_code" />
                </div>

                <label className="report-declaration">
                    <input
                        type="checkbox"
                        checked={form.declaration}
                        onChange={set("declaration")}
                        required
                    />
                    <span className="max-h-1/2">
                        Declaro que as informações prestadas são verdadeiras. Estou ciente de que
                        denúncia falsa pode configurar crime de denunciação caluniosa
                        (art. 339 do Código Penal).
                    </span>
                </label>

                <button type="submit" className="btn-primary" disabled={sending}>
                    {sending ? "Enviando..." : "Enviar denúncia"}
                </button>
            </form>

            {/* MINHAS DENÚNCIAS (no mobile, some quando o form está aberto) */}
            <div className={`report-list-card ${formOpen ? "is-hidden-mobile" : ""}`}>
                <h3><i className="fas fa-list-check" /> Minhas denúncias</h3>

                {reports.length === 0 && (
                    <span className="report-empty">Você ainda não fez nenhuma denúncia.</span>
                )}

                {reports.map((r) => (
                    <div key={r.id} className="report-item">
                        <div className="report-item-head">
                            <span className="report-item-bot">@{r.reported_bot_username}</span>
                            <StatusPill color={STATUS_COLORS[r.status] || "gray"}>
                                {r.status_label}
                            </StatusPill>
                        </div>
                        <div className="report-item-meta">
                            <span><i className="fas fa-tag" /> {r.report_type_label}</span>
                            {r.platform && <span><i className="fas fa-globe" /> {r.platform_label}</span>}
                            <span><i className="fas fa-calendar" /> {fmtDate(r.created_at)}</span>
                            {r.reviewed_at && (
                                <span><i className="fas fa-gavel" /> Analisada: {fmtDate(r.reviewed_at)}</span>
                            )}
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );
}

export default function Support() {
    const [activeTab, setActiveTab] = useState("support");

    return (
        <div className="page">
            <header className="dashboard-header">
                <h1 className="title">Suporte & Denúncia</h1>
                <p>Fale com a gente ou denuncie um bot fora das regras</p>
            </header>

            <TabNav tabs={TABS} activeTab={activeTab} onTabChange={setActiveTab} />

            {activeTab === "support" && <SupportTab />}
            {activeTab === "report" && <ReportTab />}
        </div>
    );
}
